// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-widget-content-document-listing .widget-list-item-header {
  font-size: 14px;
  line-height: 20px;
  height: 20px;
}
.fi-widget-content-document-listing .widget-list-item-date {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget/widget-content/document-listing/document-listing.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,iBAAA;EACA,YAAA;AAAR;AAEI;EACI,eAAA;AAAR","sourcesContent":[".fi-widget-content-document-listing {\r\n    .widget-list-item-header {\r\n        font-size: 14px;\r\n        line-height: 20px;\r\n        height: 20px;\r\n    }\r\n    .widget-list-item-date {\r\n        font-size: 12px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
